export enum WebPosRoutesEnum {
  STORES = 'stores',
  MENU = 'menu',
  TABLES = 'tables',
  CHECKOUT = 'checkout',
  ORDERS = 'orders',
}
